import { Box, IconButton, Typography, styled } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { color } from 'config/color'

interface IItem {
  Icon: any
  title: string
  route: string
}

export const Item = ({ title, Icon, route }: IItem): JSX.Element => {
  const navigate = useNavigate()

  const handleItem = (): void => {
    if (title === 'Outages' || title === 'Resources' || title === 'FAQ') {
      window.open(route, '_blank')
    } else {
      navigate(route)
    }
  }

  return (
    <Box width="100%" flex={1}>
      <Wrapper onClick={handleItem} border={`solid 1px ${color.background[300]}`} >
        <IconButton sx={{ background: color.background[50], borderRadius: '2px' }}>
          <Icon sx={{ color: color.primary[600] }} />
        </IconButton>
        <Typography ml={1} color={color.grey[900]} fontSize={16}>{title}</Typography>
      </Wrapper>
    </Box>
  )
}
const Wrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  background: color.white,
  borderRadius: 4,
  padding: '8px 16px 8px 8px',
  '&:hover': {
    cursor: 'pointer'
  }
})
